import { render } from "./MainHeader.vue?vue&type=template&id=e5d4011a&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=e5d4011a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d4011a"],['__file',"resources/js/System/Compenents/MainHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5d4011a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5d4011a', __exports__)) {
    api.reload('e5d4011a', __exports__)
  }
  
  module.hot.accept("./MainHeader.vue?vue&type=template&id=e5d4011a&scoped=true", () => {
    api.rerender('e5d4011a', render)
  })

}


export default __exports__